/* eslint-disable import/prefer-default-export */
import qs from 'qs';
import contentService from '../../services/contentService';
import {
  FETCH_ARTICLES_PROJEKTE_CLEAN_UP,
  FETCH_ARTICLES_PROJEKTE_FAILURE,
  FETCH_ARTICLES_PROJEKTE_REQUEST,
  FETCH_ARTICLES_PROJEKTE_SUCCESS,
  UPDATE_PROJEKTE_PAGE_START_PARAM,
} from '../constants/projekteTypes';

const fetchArticlesProjekteRequest = () => {
  return {
    type: FETCH_ARTICLES_PROJEKTE_REQUEST,
  };
};

const fetchArticlesProjekteSuccess = (payload) => {
  return {
    type: FETCH_ARTICLES_PROJEKTE_SUCCESS,
    payload,
  };
};

const fetchArticlesProjekteFailure = (error) => {
  return {
    type: FETCH_ARTICLES_PROJEKTE_FAILURE,
    payload: error,
  };
};

export const fetchArticlesProjekteCleanUp = () => {
  return {
    type: FETCH_ARTICLES_PROJEKTE_CLEAN_UP,
  };
};

export const updateProjektePageStartParam = () => {
  return {
    type: UPDATE_PROJEKTE_PAGE_START_PARAM,
  };
};

export const fetchArticlesProjekte = ({
  categories = [],
  city = undefined,
  start = undefined,
  limit = undefined,
  menu = 'projekte',
  locale = 'de',
} = {}) => {
  return (dispatch) => {
    let categoriesList = [];
    let query = '';
    categoriesList = categories.map((item) => item.id);
    if (categoriesList.length > 0) {
      query = qs.stringify(
        {
          _where: { 'categories.id': categoriesList },
        },
        { encode: false, arrayFormat: 'repeat' }
      );
    }
    const contentsQuery = `sort=publishAt%3Adesc&filters[type][$eq]=article&populate[main_image]=true${
      categoriesList.length > 0 ? `&${query}` : ''
    }${menu ? `&filters[menu][$eq]=${menu}` : ''}${
      city ? `&filters[city][$eq]=${city}` : ''
    }${start ? `&pagination[start]=${start}` : ''}${
      limit ? `&pagination[limit]=${limit}` : ''
    }`;
    dispatch(fetchArticlesProjekteRequest);
    contentService
      .getContents(contentsQuery, locale)
      .then((response) => {
        const articles = response.data;
        dispatch(
          fetchArticlesProjekteSuccess({
            articles,
            limit,
            start,
          })
        );
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchArticlesProjekteFailure(errorMsg));
      });
  };
};
